import { IconContent } from '@icons';

export const calendarFilled: IconContent = {
    sm: '<path fill-rule="evenodd" d="M5.5 4h5V2h1v2H14v10H2V4h2.5V2h1v2ZM3 7h10v6H3V7Z" />',
    md: '<path fill-rule="evenodd" d="M15.5 5h-7V3h-1v2H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3.5V3h-1v2ZM4 10.5V20h16v-9.5H4Z" />',
};
